var maintenanceMenuInit = function ($q, $rootScope, apiService, customerModelService, $log, errorRouterService) {

    errorRouterService.subscribe(function () {
        $rootScope.maintenanceMenuGetLinkError = true;
        return $q.when(true);
    }, { resourceName: 'maintenanceMenu', status: '*' });

    $rootScope.generateMaintenanceMenu = function () {

        if ($rootScope.maintenanceMenuIsPending) {
            return;
        } else if ($rootScope.maintenanceMenuLink) {
            loadMaintenanceMenuWindow();
        } else {
            $rootScope.maintenanceMenuIsPending = true;
            $rootScope.stopGenerateMaintenanceMenu = false;
            $rootScope.maintenanceMenuGetLinkError = false;

            //try create new tab window on user event before receive link
            //to prevent pop-ups blocking.
            //var win = window.open('about:blank', '_blank');

            var isGarbage = function (o) {
                return o === null || o === undefined ||
                    (_.isString(o) && o.length == 0) ||
                    ((_.isObject(o) || _.isArray(o)) && _.size(o) == 0)
            };

            apiService.getCatalog().then(function (catalog) {
                var services = customerModelService.getSelectedMaintenanceServices();
                var vehicleHref = _.get(_.find(_.get(customerModelService.getCurrentVehicle(), 'links'),
                    function (link) {
                        return link.rel == 'self' || link.rel == 'http://api.dealer-fx.com/docs/rels/vehicle';
                    }), 'href');

                var mapServiceFunction = function (o) {
                    return _.omitBy({ id: o.id, comment: o.comment }, isGarbage);
                };

                var customer = customerModelService.getCustomer();
                var currentVehicle = customerModelService.getCurrentVehicle();
                var selectedMaintenancePeriod = currentVehicle.getCurrentMaintenanceInterval();

                var data = _.omitBy({
                    vehicle: { links: [{ rel: 'http://api.dealer-fx.com/docs/rels/vehicle', href: vehicleHref }] },
                    services: {
                        repair: _.map(services.customerConcerns, mapServiceFunction),
                        frs: _.map(services.factoryRequired, mapServiceFunction),
                        drs: _.map(services.dealerRecommended, mapServiceFunction)
                    },
                    customer: { id: ((customer != undefined) && (customer.id.indexOf('dms') != -1))? null:_.get(customer, 'id') },
                    mileage: {
                        value: (selectedMaintenancePeriod && selectedMaintenancePeriod.mileage) ?
                            selectedMaintenancePeriod.mileage : _.get(customerModelService.getCurrentVehicle(), 'odometer', null),
                        unitsKind: 'mileage'
                    },
                    settings: window.appSettings.menuSettings
                }, isGarbage);

                return catalog.maintenanceMenu(data);
            }).then(function (maintenanceMenu) {
                if ($rootScope.stopGenerateMaintenanceMenu) return;
                $rootScope.maintenanceMenuLink = _.get(_.find(maintenanceMenu.links, { rel: "http://api.dealer-fx.com/docs/rels/maintenance-menu+pdf" }), 'href');
                loadMaintenanceMenuWindow();
                //load PDF into new window
                //win.location.href = $scope.maintenanceMenuLink;
            }).catch(function (err) {
                //win.close();
                //$log.error('Something went wrong', err);
            }).finally(function () {
                $rootScope.maintenanceMenuIsPending = false;
            });
        }
    };

    var cleanState = function () {
        $rootScope.maintenanceMenuIsPending = false;
        $rootScope.maintenanceMenuLink = null;
        $rootScope.stopGenerateMaintenanceMenu = true;
    };

    $rootScope.$on('ServiceItemController:serviceChanged', cleanState);
    $rootScope.$on('FactoryRequiredCtrl:changeInterval', cleanState);

    //loadMaintenanceMenuWindow
    //
    //@description
    //opens new window to show just generated maintenance menu
    function loadMaintenanceMenuWindow() {

        //open generated menu in a new tab
        var win = window.open($rootScope.maintenanceMenuLink, '_blank');
        //focus window where maintenance menu was loaded
        //ToDo:
        //I do not know the final desision if it is required to lead
        //user to the new window or it is needed to stay on current
        if (win) {
            win.focus();
        }
    }

};

maintenanceMenuInit.$inject = ['$q', '$rootScope', 'apiService', 'customerModelService', '$log', 'errorRouterService'];

module.exports = maintenanceMenuInit;
